import { Component, OnInit, Injector, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { BillingModel, CommonModel } from 'src/modules/payment/components/common/billing.model';
import { ActivatedRoute } from '@angular/router';
import { BillingService } from 'src/modules/payment/service/billing.service';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { PayorDetailsComponent } from '../payor-details/payor-details.component';
import { SearchAndSelect } from 'src/modules/base/components/form/models/serachselect.model';
import { CommonService } from 'src/modules/base/services/common.service';
import { FacilitySearchSelectModel } from 'src/modules/base/base.component';
import { Properties } from '../../models/pharmacyModel';
import * as CryptoJS from 'crypto-js';

@Component({
    selector: 'kx-co-payer-pharmacy',
    templateUrl: './co-payer-pharmacy.component.html',
    styleUrls: ['./co-payer-pharmacy.component.scss'],
    standalone: false
})
export class CoPayerPharmacyComponent extends MainComponent implements OnInit {
  billingModel: BillingModel;
  pharmacyModel: Properties;
  @ViewChild("treatingDcotorSelector") treatingDcotorSelector: any;
  @ViewChild("facilitySelector") facilitySelector: any;
  @ViewChild("referTypeSelector") referTypeSelector: any;
  commonModel: CommonModel;
  _currentData: any = {};
  @Input() patientInfo: any; @Input() disableAll: boolean = false;
  @Input() payment: any;
  @Input() isApprovedScreen: any;
  @Output() updatePayorInfo: EventEmitter<any> = new EventEmitter();
  @Output() referUpdate: EventEmitter<any> = new EventEmitter();
  @Output() isTreatingDoctorRequired: EventEmitter<any> = new EventEmitter();
  @Output() selectedTreatingDoctor: EventEmitter<any> = new EventEmitter();
  @Output() isReffereedByReq: EventEmitter<any> = new EventEmitter();
  payerExpired: boolean = false;
  threatingRequired: boolean = false;
  refferedConfigReq: boolean;
  isInsuranceMandatory = false;
  treatingDoctor: any;
  isTreatingDoctorApiCalled: boolean;
  treatingDrModel: any = "";
  referType: any;
  referTypeModel: any = "";
  isFreeTextDoctor:boolean=false;
  facilityModel: any = "";
  isFacilityDisabled: boolean = true;
  facilitySearchSelect: FacilitySearchSelectModel;
  resource:string="";

  referTypeQuestion = new SearchAndSelect({
    format: "(item) => `${item.referType_name}`",
    datasource: {
      "application": "facility-management",
      "resource": "refer_type_master",
      "query_id": "GET_ALL",
      "args": "referType:referredName.referType",
      "filter": "status:active"
    },
    defaultsetting: {
      "singleSelection": true,
      "advancesearch": false,
      "allowSearchFilter": true,
      "closeDropDownOnSelection": true,
      "checkBoxRequired": false,
      "apliCall": false,
    },
    getterKey: 'referType',
    getterValue: 'referType_name',
    key: "referType",
    name: "referType",
    type: "string",
    req_keys: "all",
    value: ""
  });
  treatingQuestion = new SearchAndSelect({
    format: "(item) => `${item.firstName} || ${item.facility_name}`",
    datasource: {
      possible_value: []
      // "application": "facility-management",
      // "resource": "refer",
      // "query_id": "GET_REFER_BY_REFERTYPE",
      // "args": "facility_id:" + "" + ",status:" + "active" + ",referType:" + "treating_doctor",
    },
    defaultsetting: {
      "singleSelection": true,
      "advancesearch": false,
      "allowSearchFilter": true,
      "closeDropDownOnSelection": true,
      "checkBoxRequired": false,
      "apliCall": false,
      "config_key_free_text": "op_billing_treating_doctor",
      "freeText": true
    },
    getterKey: 'practitioner_id',
    getterValue: 'firstName',
    key: "practitioner_id",
    "name": "treatingDoctor",
    type: "string",
    req_keys: "all",
    value: ""
  });
  payerQuestion;
  payerId: any;
  refferdMandatory: boolean;
  cacheObj: any;
  isPayerRemoved: boolean;
  config_value : any;
  constructor(
    public injector: Injector,
    public route: ActivatedRoute,
    public billingService: BillingService,
    public commonService: CommonService
  ) {
    super(injector, route);
    this.billingModel = new BillingModel();
    this.pharmacyModel = new Properties();
    this.commonModel = new CommonModel();
    this.facilitySearchSelect = new FacilitySearchSelectModel(); this._currentData.org = {}
    this._currentData.showFacility = false;
  }

  setTreatingDoctor() {// Not in use
    if ((this.patientInfo.doctorId || this.patientInfo.treatingDoctorId) && this.treatingDrModel == "" && this.treatingDoctor) {
      let data = this.patientInfo;
      if (data && data.doctorId) {
        let currentDoctor = this.treatingDoctor.find((f) => { return f.practitioner_id == data.doctorId })
        this.treatingDrModel = currentDoctor.practitioner_id;
      } else if (data && data.treatingDoctorId) {
        let currentDoctor = this.treatingDoctor.find((f) => { return f.practitioner_id == data.treatingDoctorId })
        this.treatingDrModel = currentDoctor.practitioner_id;
      } else if (!this.treatingDrModel) {
        debugger;
      }
    }
  }
  search(nameKey, myArray, searchKey) {
    let obj = myArray.find(o => o[searchKey] === nameKey);
    return obj;
  }
  getOrganization() {
    if (this.appService.getOrganizationList().length > 0) {
      this._currentData.organizations = this.appService.getOrganizationList();
      this.facilitySearchSelect.datasource.possible_value = this.appService.getOrganizationList();
      this.facilitySearchSelect.defaultsetting.hasAppliedCss = false;
      delete this.facilitySearchSelect.defaultsetting.location_icon;
      this._currentData.showFacility = true;
      if (this.appService.getOrganization()) {
        let currentOrg = this.appService.getOrganization();
        this._currentData.orgId = currentOrg.org_id;
        // This is written so that if changed in master it should reflect on hard refresh
        this._currentData.org = this._currentData.organizations.find(val => {
          return val.org_id == this._currentData.orgId;
        });
      } else {
        this._currentData.orgId = this._currentData.organizations[0].org_id;
        this._currentData.org = this.search(this._currentData.orgId, this._currentData.organizations, 'org_id');
      }
      var obj = {};
      obj[this.appService._appData.ORG_KEY] = this._currentData.orgId;
      this.appService.setOrganization(this._currentData.org);
      this.getTreatingDoctor("", this._currentData.orgId);
      setTimeout(() => {
        this.facilityModel = this._currentData.orgId//currentOrg;
        this.facilitySelector.writeValue(this.facilityModel);
      }, 500);

    }
  }
  ngOnInit() {
    console.log("Patient Info ", this.patientInfo);
    this.getPayerNames();
    this.bindRefferTypeDropDown();
    // this.billingModel.treating_doctor = "";
    this.getTreatingDoctorConfig();
    this.getRefferedByConfig('pharmacy');
    this.getFacilityConfig();
    this.makePayerQuestion();
    this.getInsuranceMandatoryConfig();
    this.getRefferLetterNoMandatoryConfig();
    if (this.route.snapshot.data.hasOwnProperty("resource")) {
      this.resource = this.route.snapshot.data.resource;
    }
  }
  makePayerQuestion() {
    this.payerQuestion = new SearchAndSelect({
      datasource: {
        "application": "facility-management",
        "resource": "payer",
        "query_id": "GET_PAYER",
        "args": `payer_for:pharmacy_billing,noCount:1,uhId:${this.getUhId()},rule_context:payerContext`,
        "possible_value": []
      },
      req_keys: ["id","payerId","payer_id","payer_group","payer_group_id","payer_master_id","payer_name","payer_sub_group","payer_sub_group_id","payer_type","payer_type_name","payer_base_tariff_id","payment_type","payment_typeId","status","status_name","confirm_order","payer_code","facility_id","co_pay_details"],
      defaultsetting: {
        "singleSelection": true,
        "allowSearchFilter": true,
        "closeDropDownOnSelection": true,
        "checkBoxRequired": false,
        "apliCall": false
      },
      getterKey: 'id',
      getterValue: 'payer_name',
      key: "id",
      options: true,
      type: "string",
      value: ""
    });
  }
  getRefferedByConfig(module): any {
    let filter = `config_code:Ph_89,module_code:${module}`
    this.baseService.get("GET_PAGE", '', "facility_config_mapping", "facility-management", filter).subscribe((result: any) => {
      if (result.errCode == 0) {
        if (result.resource && result.resource.length > 0) {
          let res = result.resource[0]
          if (res.multivalue && res.multivalue.length > 0 && res.status == 'active') {
            let isActive = res.multivalue.find((d) => { return d.id == 'pharmacy_billing' });
            if (isActive) {
              this.refferedConfigReq = true
              this.isReffereedByReq.emit({ refferByReq: true });
            } else {
              this.refferedConfigReq = false
              this.isReffereedByReq.emit({ refferByReq: false });
            }
          }
        }
      } else {
        this.refferedConfigReq = false
        this.isReffereedByReq.emit({ refferByReq: false });
      }
    }, (err) => {
      this.refferedConfigReq = false
      this.isReffereedByReq.emit({ refferByReq: false });
    })
  }
  
  ngAfterViewInit() {
    // if(this.patientInfo){
    //   this.setTreatingDoctor();
    // }
    this.getOrganization();
    //this.getSetPayerDetails(); 
    //this.treatingDcotorSelector
  }
  getSetPayerDetails() {
    let payerInfo = this.patientInfo;
    if (payerInfo) {
      if (payerInfo != undefined && payerInfo.payer_id) {
        this.billingModel.payerId = payerInfo.payer_id;
        // this.billingModel.payerName = payerInfo.payer_name;
        // this.billingModel.payer_type = payerInfo.payer_type;
        let payer = this.billingModel.getPayerData.find(val => {
          return val.id == this.billingModel.payerId;
        });
        if (payer != undefined) {
          this.billingModel.payerId = payer.id;
          this.payerId = payer.id;
          this.payerQuestion.value = this.billingModel.payerId;
          this.billingModel.payerName = payer.payer_name;
          this.billingModel.payer_type = payer.payer_type;
          this.billingModel.payment_typeId = payer.payment_typeId;
          if (this.billingModel.payer_type != 'cash') {
            this.checkPayer(payerInfo, true);
            this.billingModel.payerInputData = {
              "payer_type": this.billingModel.payer_type,
              "payer_id": this.billingModel.payerId,
              "payer_name": this.billingModel.payerName,
              "payment_typeId": this.billingModel.payment_typeId
            }
          } else {
            this.billingModel.payerInputData = {
              "payer_type": this.billingModel.payer_type,
              "payer_id": this.billingModel.payerId,
              "payer_name": this.billingModel.payerName,
              "payment_typeId": this.billingModel.payment_typeId
            }
            this.updatePayorInfo.emit({ currentData: payerInfo, hitApt: true, payerExpiry: this.payerExpired, eventName: "payer_change" })
          }
        } else {
          let payerName = this.billingModel.getPayerData.find(val => {
            return val.payer_type == 'cash';
          });
          if (payerName != undefined) {
            this.billingModel.payerId = payerName.id;
            this.payerId = payerName.id;
            this.billingModel.payerName = payerName.payer_name;
            this.billingModel.payer_type = payerName.payer_type;
            this.billingModel.payment_typeId = payerName.payment_typeId;
          }
        }
      } else {
        let payerName;
        if (this.billingModel.getPayerData) {
          payerName = this.billingModel.getPayerData.find(val => {
            return val.payer_type == 'cash';
          });
        }
        this.billingModel.payerInputData = {
          "payer_type": this.billingModel.payer_type,
          "payer_id": this.billingModel.payerId,
          "payer_name": this.billingModel.payerName,
          "payment_typeId": this.billingModel.payment_typeId
        }
        if (payerName != undefined) {
          this.billingModel.payerId = payerName.id;
          this.billingModel.payerName = payerName.payer_name;
          this.billingModel.payer_type = payerName.payer_type;
          this.billingModel.payment_typeId = payerName.payment_typeId;
          this.billingModel.payerInputData = {
            "payer_type": this.billingModel.payer_type,
            "payer_id": this.billingModel.payerId,
            "payer_name": this.billingModel.payerName,
            "payment_typeId": this.billingModel.payment_typeId
          }
          if (!payerInfo.hasOwnProperty('payer_type')) {
            payerInfo["payer_type"] = payerName.payer_type,
              payerInfo["payer_id"] = payerName.id,
              payerInfo["payer_name"] = payerName.payer_name,
              payerInfo["payment_typeId"] = payerName.payment_typeId
            if (this.billingModel.payer_type != 'cash') {
              this.checkPayer(payerInfo, false);
            }
            //this.updatePayorInfo.emit({ currentData: payerInfo, hitApt: false, payerExpiry: this.payerExpired})
          }
        }
      }
    }
  }
  checkPayer(obj?, hitApt?) {
    if (this.patientInfo) {
      this.loader.showSpinner();
      if (this.patientInfo.uhId || this.patientInfo.preRegistrationNo) {
        let data = {
          'args': 'id:' + this.billingModel.payerId + ",uhId:" + (this.patientInfo.uhId ? this.patientInfo.uhId : this.patientInfo.preRegistrationNo),
          "query_id": "CHECK_PAYER_EXPRIY"
        }
        this.baseService.getData(data, "", 'payer', 'facility-management', 'CHECK_PAYER_EXPRIY').subscribe(
          result => {
            if (result.errCode == 0) {
              this.payerExpired = false;
              this.updatePayorInfo.emit({ currentData: obj, hitApt: hitApt, payerExpiry: this.payerExpired, eventName: "payer_change" })
              console.log("Result ", result.resource);
            } else {
              this.payerExpired = true;
              this.updatePayorInfo.emit({ currentData: obj, hitApt: hitApt, payerExpiry: this.payerExpired, eventName: "payer_change" })
              this.alerts.error(result.message);
            }
            this.loader.hideSpinner();
          }
        )
      }
    }
  }
  getUhId() {
    if (this.patientInfo) {
      if (this.patientInfo.uhId) {
        return this.patientInfo.uhId;
      } else if (this.patientInfo.preRegistrationNo) {
        return this.patientInfo.preRegistrationNo;
      }
    }
  }
  getPayerNames() {          // To get Payer List
    let resource = this.billingModel.getPayerArgs;
    var data = {
      args: `payer_for:pharmacy_billing,noCount:1,uhId:${this.getUhId()},rule_context:payerContext`,
      projectionKeys: "id,payerId,payer_id,payer_group,payer_group_id,payer_master_id,payer_name,payer_sub_group,payer_sub_group_id,payer_type,payer_type_name,payer_base_tariff_id,payment_type,payment_typeId,status,status_name,confirm_order,payer_code,facility_id,co_pay_details"
    }
    this.baseService.getData(data, "", resource.resource, resource.application, resource.query_id).subscribe(
      result => {
        if (result.errCode == 0) {
          this.billingModel.getPayerData = result.resource;
          this.payerQuestion.datasource = { ...this.payerQuestion.datasource, possible_value: this.billingModel.getPayerData };
          this.getSetPayerDetails();
        }
      }
    )
  }

  changePayer(event) {    // After changing payer this function is called
    if (!event) {
      console.log("payer not selected");
      this.updatePayorInfo.emit({ currentData: obj, hitApt: true, payerExpiry: true, eventName: "payer_removed" });
      this.isPayerRemoved = true;
      return
    }
    this.isPayerRemoved = false;
    this.billingModel.payerId = event
    let payerName = this.billingModel.getPayerData.find(val => {
      return val.id == event; //event.target.value;
    });
    this.billingModel.payerName = payerName.payer_name;
    this.billingModel.payer_type = payerName.payer_type;
    this.billingModel.payment_typeId = payerName.payment_typeId;
    this.billingModel.copay_details = payerName.co_pay_details
    this.billingModel.payerInputData = {
      "payer_type": this.billingModel.payer_type,
      "payer_id": this.billingModel.payerId,
      "payer_name": this.billingModel.payerName,
      "payment_typeId": this.billingModel.payment_typeId,
      "co_pay_details": this.billingModel.copay_details
    }
    console.log("patient data ", this.patientInfo);
    var obj = { ...this.patientInfo, ...this.billingModel.payerInputData };
    if (this.billingModel.payer_type != 'cash') {
      this.checkPayer(obj, true);
      //this.updatePayorInfo.emit({ currentData: obj, hitApt: true, payerExpiry: this.payerExpired })
    } else {
      this.payerExpired = false;
      this.updatePayorInfo.emit({ currentData: obj, hitApt: true, payerExpiry: this.payerExpired, eventName: "payer_change" })
    }

  }

  bindRefferTypeDropDown() { //refer_type_master
    let resource = this.billingModel.getReferralNamesArgs;
    let data = {
      args: this.billingService.setArguments(resource.args)
    }
    this.baseService.getData(data, "", "refer_type_master", "facility-management", "GET_ALL").subscribe(
      result => {
        if (result.errCode == 0) {
          this.billingModel.getReferralTypes = result.resource;
          // this.referTypeQuestion.datasource.possible_value = this.billingModel.getReferralTypes;
          // if(this.patientInfo.doctorId){ // If there is doctor id coming then set that doctor for REFFFERED BY
          //   let referredName = this.billingModel.getReferralTypes.find(val => {
          //     return val.referType_name == 'Internal Doctor';
          //   })
          //   if(referredName){
          //     this.billingModel.referType = referredName.referType;
          //     this.getReferralNames(this.billingModel.referType, this.patientInfo.doctorId);
          //   }else{
          //     this.getReferralNames(this.billingModel.referType);
          //   }
          // }
          if (this.patientInfo && this.patientInfo.hasOwnProperty('patient_referral_information') && this.patientInfo?.patient_referral_information?.referType) { // if referType is coming in patient data
            this.billingModel.referType = this.patientInfo.patient_referral_information.referType;
            if (this.billingModel.referType == "other") {
              this.billingModel.referred_by_name = this.patientInfo.patient_referral_information.refer_name_textbox ? this.patientInfo?.patient_referral_information?.refer_name_textbox : '';
            }
            this.billingModel.referredById = this.patientInfo.patient_referral_information.refer_name ? this.patientInfo.patient_referral_information.refer_name : '';
            this.filledReferedtypeInfo()
            this.getReferralNames(this.billingModel.referType);
            if (!this.billingModel.referType && this.patientInfo?.patient_referral_information?.referType) {
              setTimeout(() => {
                this.billingModel.referType = this.patientInfo?.patient_referral_information?.referType;
              }, 1500);
            }
          } else { // else Setting default referType
            let referredName = this.billingModel.getReferralTypes.find(val => {
              return val._default == true;
            })
            if (referredName) {
              this.billingModel.referType = referredName.referType;
              this.filledReferedtypeInfo();
              this.getReferralNames(this.billingModel.referType);
            }
            this.filledReferedtypeInfo()
          }
        }
      }
    )
  }

  filledReferedtypeInfo() {
    setTimeout(() => {
      let isFilled = false;
      if (this.patientInfo && this.patientInfo.op_walkin_order && this.patientInfo.op_walkin_order.referType) {
        let pt = this.billingModel.getReferralTypes.find(x => x.referType_name == this.patientInfo?.op_walkin_order?.referType);
        if (pt) {
          this.billingModel.referType = pt.referType;
          isFilled = true;
          if (this.billingModel.isFacilityOrPerson == "Other") {
            this.billingModel.referred_by_name = this.patientInfo.op_walkin_order.referred_by_name;
          }
        }
      }

      if (this.patientInfo && this.patientInfo?.op_medication_order && this.patientInfo?.op_medication_order?.referType) {
        let data = this.billingModel.getReferralTypes.find(x => x.referType_name == this.patientInfo?.op_medication_order?.referType);
        if (data) {
          this.billingModel.referType = data.referType;
          isFilled = true;
          if (this.billingModel.isFacilityOrPerson == "Other") {
            this.billingModel.referred_by_name = this.patientInfo?.op_medication_order?.referred_by_name;
          }
        }
      }
      else {
        // if(!isFilled){
        //   let d = this.patientInfo?.patient_referral_information?.referType_other;
        //   if(d){
        //     let data = this.billingModel.getReferralTypes.find(x => x.referType_name == d);
        //   if (data){
        //     this.billingModel.referType = data.referType;
        //     isFilled= true;
        //   }
        //   }
        // }
      }
    }, 500);
  }

  getReferralNames(event, participant_details?) {
    if (event.alldata != undefined) {
      if (event.alldata && event.alldata != "") {
        this.billingModel.isFacilityOrPerson = event.alldata.isFacilityOrPerson;
        this.billingModel.referType_name = event.alldata.referType_name;
      }
      else {
        this.billingModel.isFacilityOrPerson = event.id;
        this.billingModel.referType_name = event.id;
      }
    } else {
      this.billingModel.isFacilityOrPerson = event.id;
      this.billingModel.referType_name = event.id;
    }
    let resource = this.billingModel.getReferralNamesArgs;
    let data = {
      args: this.billingService.setArguments(resource.args) + `,referType:${event.id ? event.id : ''}`
    }
    if (this.billingModel.isFacilityOrPerson && this.billingModel.isFacilityOrPerson != "Other") {
      this.baseService.getData(data, "", resource.resource, resource.application, resource.query_id).subscribe(
        result => {
          if (result.errCode == 0) {
            this.billingModel.getReferralNamesData = result.resource;
            if (participant_details != undefined) { // Need to re-check if block only
              let referredName = this.billingModel.getReferralNamesData.find(val => {
                return val.practitioner_id == participant_details;
              })
              if (referredName) {
                this.billingModel.referredById = referredName.id;
              }
            } else {
              this.billingModel.referredById = "";
              this.billingModel.referred_by_name = "";
            }
            this.fillReferedName(event)
          }
        }
      )
    } else {
      this.fillReferedName(event)
    }
    this.referUpdate.emit({ type: "referType", referType: this.billingModel?.referType, referType_name: this.billingModel.referType_name, isFacilityOrPerson: this.billingModel.isFacilityOrPerson, payerExpiry: this.payerExpired })
  };

  fillReferedName(event) {
    setTimeout(() => {
      if (this.patientInfo && this.patientInfo.op_walkin_order) {
        if (this.patientInfo.op_walkin_order.referred_by_id) {
          this.billingModel.referredById = this.patientInfo.op_walkin_order.referred_by_id;
          this.billingModel.referByName = this.patientInfo.op_walkin_order.referred_by_name
        } else {
          if (this.billingModel.isFacilityOrPerson == "Other") {
            // draft stores the refer type's display name, so match on either id or name
            const draftReferType = this.patientInfo.op_walkin_order.referType;
            if (event?.id != draftReferType && event?.alldata?.referType_name != draftReferType) {
              this.billingModel.referred_by_name = ""
            } else {
              this.billingModel.referred_by_name = this.patientInfo?.op_walkin_order?.referred_by_name
            }

            //   this.billingModel.referred_by_name = this.patientInfo.op_walkin_order.referred_by_name;
          }
        }
      }



      if (this.patientInfo && this.patientInfo.op_medication_order) {
        if (this.patientInfo.op_medication_order.referred_by_id) {
          this.billingModel.referredById = this.patientInfo.op_medication_order.referred_by_id;
          this.billingModel.referByName = this.patientInfo.op_medication_order.referred_by_name
        } else {
          if (this.billingModel.isFacilityOrPerson == "Other") {
            if (event.id != this.patientInfo?.patient_referral_information?.referType) {
              this.billingModel.referred_by_name = ""
            } else {
              this.billingModel.referred_by_name = this.patientInfo?.op_medication_order?.referred_by_name
            }

            //   this.billingModel.referred_by_name = this.patientInfo.op_medication_order.referred_by_name;
          }     
        }
      }

    }, 0);
    // a walk-in draft's own referral takes priority over the patient's registration referral
    if (this.patientInfo && this.patientInfo.patient_referral_information && !this.patientInfo.op_walkin_order?.referType) {
      setTimeout(() => {

        this.billingModel.referredById = this.patientInfo?.patient_referral_information?.refer_name ? this.patientInfo.patient_referral_information.refer_name : '';
        this.billingModel.referByName = this.patientInfo.patient_referral_information.refer_name_value ? this.patientInfo.patient_referral_information.refer_name_value : '';
        if (this.billingModel.getReferralNamesData && this.billingModel.getReferralNamesData.length > 0) {
          let data = this.billingModel.getReferralNamesData.filter((d) => { return d.id == this.billingModel.referredById });
          if (data && data.length == 0) {
            this.billingModel.referredById = "";
            this.billingModel.referByName = "";
          }
        } else if (this.billingModel.isFacilityOrPerson == "Other") {
          if (event.id != this.patientInfo?.patient_referral_information?.referType) {
            this.billingModel.referred_by_name = ""
          } else {
            this.billingModel.referred_by_name = this.patientInfo?.patient_referral_information?.refer_name_textbox ? this.patientInfo.patient_referral_information.refer_name_textbox : '';
          }

          //       this.billingModel.referred_by_name = this.patientInfo.patient_referral_information.refer_name_textbox ? this.patientInfo.patient_referral_information.refer_name_textbox : '';
        } else {
          this.billingModel.referredById = "";
          this.billingModel.referByName = "";
        }
      });
    }
  }

  getReferByName(event) {
    if (this.billingModel && this.billingModel.getReferralNamesData && this.billingModel.getReferralNamesData.length > 0 && this.billingModel.referType != 'other') {
      let data = this.billingModel.getReferralNamesData.find((d) => {
        return d.id == event.target.value
      });
      if (data) {
        this.referUpdate.emit({ type: "referBy", referred_by_id: event.target.value, referred_by_name: data.firstName, referType: this.billingModel.referType, payerExpiry: this.payerExpired })
      }
    } else if (this.billingModel.referType == 'other') {
      //TODO
      this.referUpdate.emit({ type: "referBy", referred_by_id: "", referred_by_name: this.billingModel['referred_by_name'], referType: this.billingModel.referType, payerExpiry: this.payerExpired })
    }
  }
  getPriceAPI(args, event?) {         // To get Price API
    let resource = this.commonModel.getPrice;
    resource['data'] = args;
    this.baseService.action(resource['data'], resource.action, resource.application, resource.resource).subscribe(response => {
      if (response.errCode == 0) {
        this.billingModel.dataTableData = response.resource[0].services;
        this.billingModel.dataTableData.forEach(element => {
          element['paymentStatus'] = 'completed';
          if (element['total_amount'] == undefined) {
            element['total_amount'] = element['amount'];
          }
          element['discountValue'] = element['discount'];
          if (element['serviceType_code'] == 'op_consultation') {
            element['consultation_type'] = 'opd';
          }
        });
        //this.sendToPayment(event);
      }
    });
  }
  openPayerInput(event) {          //Opening payer popup
    let data = {}
    if (this.billingModel.payerInputData && this.billingModel.payerInputData.payer_type && this.billingModel.payerInputData.payer_type != 'cash' && this.patientInfo.payer_type && this.billingModel.payerInputData.payer_type && this.patientInfo.payer_type == this.patientInfo.payer_type && this.billingModel.payerInputData.payer_id == this.patientInfo.payer_id) {
      data['sponser_id'] = this.patientInfo.sponsorId;
      data['sponsor_name'] = this.patientInfo.sponsorName;
      data['policy_number'] = this.patientInfo.policyNo;
      data['policy_limit'] = this.patientInfo.policyLimit;

      data['ref_letter_number'] = this.patientInfo.ref_letter_number || this.patientInfo.preAuthReferenceNumber;
      data['applicableFromDate'] = this.patientInfo.applicableFromDate;
      data['applicableToDate'] = this.patientInfo.applicableToDate;
      data = { ...data, ...this.patientInfo };
      if (this.isApprovedScreen) {
        if (this.payment && this.payment.hasOwnProperty('op_amount_value_final')) {
          this.billingModel.payerInputData = { ...this.billingModel.payerInputData, ...this.payment.op_amount_value };
          data = { ...this.billingModel.payerInputData, ...this.payment.op_amount_value };
        } else {
          if (this.payment && this.payment.hasOwnProperty('op_amount_value')) {
            this.billingModel.payerInputData = { ...this.billingModel.payerInputData, ...this.payment.op_amount_value };
            data = { ...this.billingModel.payerInputData, ...this.payment.op_amount_value };
          }
        }
      }
      this.billingModel.payerInputData.authorized_amount = this.payment.payer_amount != undefined ? this.payment.payer_amount : 0;
      data['authorized_amount'] = this.payment.payer_amount != undefined ? this.payment.payer_amount : 0;

      if (!this.billingModel.payerInputData.payer_id) {
        this.billingModel.payerInputData.payer_id = this.billingModel.payerId;
        data['payer_id'] = this.billingModel.payerId;
      }
      data['insurance_mandatory'] = this.isInsuranceMandatory;
      data['refLetterMandatory'] = this.config_value;
      if (this.resource && (this.resource === 'pharmacy_OP_Walkin_Draft' || this.resource === 'pharmacy_OP_Order_Draft')) {
        data['patientPercentage'] = 0;
        data['isCoPay'] = false;
        data['co_pay_applicable_on'] = '';
        data['co_pay_type'] = '';
      }
    }
    this.smartModalService.open(PayorDetailsComponent, data, "Payer Input", ModalSize.Md).subscribe(
      data => {
        this.billingModel.payerInputData = data.result.result;
        let args = {
          "payer_details": this.billingModel.payerInputData,
          "patient_id": this.patientInfo['id'],
          "facility_id": this.appService.getOrganization().org_id,
          "orderId": this.billingModel.orderId,
          "is_previous_order_required": false,
          "services": this.billingModel.dataTableData
        }
        if (data && data.result && data.result.result && !data.result.result.hasOwnProperty('pin')) {
          this.updatePayorInfo.emit({ payerForm: data.result.result, hitApt: true, payerExpiry: this.payerExpired })
        }
        //this.getPriceAPI(args);
      },
      err => {
        this.updatePayorInfo.emit();
        this.dialogRef.close();
        //console.log('payer input error is as ::', err)
      }
    )
  }

  getTreatingDoctorConfig() {
    //this.loader.showSpinner();
    let filter = `config_code:ph_041,module_code:pharmacy`
    this.baseService.get("GET_PAGE", '', "facility_config_mapping", "facility-management", filter).subscribe((result: any) => {
      if (result.errCode == 0) {
        console.log("Treating Doctor response is", result);
        if (result.resource && result.resource.length > 0 && result.resource[0].config) {
          if (result.resource[0].config_value == 'true') {
            this.threatingRequired = true;
            this.isTreatingDoctorRequired.emit({ threatingRequired: true });
          } else {
            this.threatingRequired = false;
            this.isTreatingDoctorRequired.emit({ threatingRequired: false });
          }
        }
        //this.loader.hideSpinner();
      } else {
        this.threatingRequired = false;
        this.isTreatingDoctorRequired.emit({ threatingRequired: false });
        this.alerts.error(result.message);
        //this.loader.hideSpinner();
      }
    })
  }
  // changeTreatingDoctor(event){
  //   if(event && this.treatingDrModel){
  //     let curentDoctor = this.treatingDoctor.find((d)=>{return d.id == this.treatingDrModel})
  //     this.selectedTreatingDoctor.emit({treatingDoctorIs:event,id:this.treatingDrModel,currentDoctor:curentDoctor});
  //   }else if(!this.treatingDrModel){
  //     this.selectedTreatingDoctor.emit({treatingDoctorIs:event,id:'',currentDoctor:{}});
  //   }
  // }
  checkUHID() {
    if (this.disableAll)
      return true
    if (this.patientInfo.hasOwnProperty('uhId') && this.patientInfo.uhId) {
      return false;
    }
    return true
  }
  setTreatingDoctorResponse(resource) {
    this.treatingDoctor = resource;
    this.treatingQuestion.datasource.possible_value = this.treatingDoctor;
    this.treatingQuestion.options = this.treatingDoctor;
    this.treatingQuestion = JSON.parse(JSON.stringify(this.treatingQuestion))
    if (this.patientInfo && this.patientInfo.op_walkin_order && this.patientInfo.op_walkin_order.freeTextTreatingDoctor){
        this.isFreeTextDoctor = true;
    }
    setTimeout(() => {
      if (this.patientInfo && this.patientInfo.op_walkin_order && this.patientInfo.op_walkin_order.treatingDoctorId)
        //Freetext walkinApprove work
        if (this.isFreeTextDoctor) {
            this.setFreeTextDoctorById(this.patientInfo.op_walkin_order.treatingDoctorId);
        } else {
          this.treatingDrModel = this.patientInfo.op_walkin_order.treatingDoctorId
        } 
      if (this.patientInfo && this.patientInfo.op_medication_order && this.patientInfo.op_medication_order.treatingDoctorId)
        this.treatingDrModel = this.patientInfo.op_medication_order.treatingDoctorId

      if (sessionStorage.getItem('current_doctor') && !this.treatingDrModel) {
        let data = JSON.parse(sessionStorage.getItem('current_doctor'));
        if (data && data.doctorId) {
          let currentDoctor = this.treatingDoctor.find((f) => { return f.practitioner_id == data.doctorId })
          this.treatingDrModel = currentDoctor.practitioner_id;
          this.treatingDcotorSelector.writeValue(this.treatingDrModel);
        } else if (data && data.treatingDoctorId) {
          let currentDoctor = this.treatingDoctor.find((f) => { return f.practitioner_id == data.treatingDoctorId })
          if (currentDoctor) {
            this.treatingDrModel = currentDoctor.practitioner_id;
            this.treatingDcotorSelector.writeValue(this.treatingDrModel);
          } else if (!currentDoctor && data && data.treatingDoctorId) {
            //FreeText Draftwork
            this.setFreeTextDoctorById(data.treatingDoctorId);
          }
        } else if (!this.treatingDrModel) {
          debugger;
        }
      }
      //this.loader.hideSpinner();
    }, 1000);
  }

  setFreeTextDoctorById(doctorId: any) {
    const freetextDoctor = {
      practitioner_id: doctorId,
      firstName: doctorId,
      id: doctorId,
      isFreeText: true,
      speciality_name:"",
      speciality_code:"",
    };
    this.treatingDoctor.push(freetextDoctor);
    this.treatingQuestion.datasource.possible_value = this.treatingDoctor;
    this.treatingQuestion = JSON.parse(JSON.stringify(this.treatingQuestion));
    this.treatingDrModel = doctorId;
    setTimeout(() => {
      if (this.treatingDcotorSelector) {
        this.treatingDcotorSelector.writeValue(doctorId);
        if (this.treatingDcotorSelector.onChange) {
          this.treatingDcotorSelector.onChange(doctorId);
        }
      }
    }, 300);
  }

  getTreatingDoctor(event?, facilityId?) {
    //this.loader.showSpinner();
    let resource = this.billingModel.getReferralNamesArgs;
    let data = {
      args: this.billingService.setArguments(resource.args) + `,noCount:1,referType:${event ? event : 'treating_doctor'}`,
      projectionKeys: "id,practitioner_id,firstName,facility_name,doctor_code,speciality_code,speciality_name,facilityId"
    }
    if (facilityId) {
      data.args += `,facilityId:${facilityId}`
    }
    this.cacheObj = data.args + data.projectionKeys + "refer" + "facility-management" + "GET_REFER_BY_REFERTYPE" + "Treating_doctor";
    let key = CryptoJS.MD5(this.cacheObj).toString();
    if (this.baseService.getCachedData(key)) {
      if (this.baseService.getCachedData(key)) {
        const res = this.baseService.getCachedData(key);
        const excludFreeText = res.filter((dr) => !dr.isFreeText);
        this.setTreatingDoctorResponse(excludFreeText);
      }

    } else {
      if (!this.isTreatingDoctorApiCalled) {
        this.isTreatingDoctorApiCalled = true;
        this.baseService.getData(data, "", 'refer', 'facility-management', 'GET_REFER_BY_REFERTYPE').subscribe(
          result => {
            if (result.errCode == 0 && result.resource.length > 0) {
              this.setTreatingDoctorResponse(result.resource);
              let key = CryptoJS.MD5(this.cacheObj.toString()).toString();
              this.baseService.setCachedData(key, result.resource);
            } else {
              //this.loader.hideSpinner();
            }
          }
        )
      }
    }
  };
  onTreatingDoctorDeselect(event) {
    this.selectedTreatingDoctor.emit();
  }
  onTreatingDoctorSelect(event) {
    if (event && this.treatingDrModel && this.treatingDoctor) {
      let curentDoctor = this.treatingDoctor.find((d) => { return d.practitioner_id == this.treatingDrModel });
      if (curentDoctor) {
        event["is_treating_free"]= false
        this.selectedTreatingDoctor.emit({ treatingDoctorIs: event, id: this.treatingDrModel, currentDoctor: curentDoctor });
      } else {
        event["is_treating_free"]= true 
        this.selectedTreatingDoctor.emit({ treatingDoctorIs: event, id: this.treatingDrModel });
      }
    } else if (!this.treatingDrModel) {
      event["is_treating_free"]= false
      this.selectedTreatingDoctor.emit({ treatingDoctorIs: event, id: '', currentDoctor: {} });
    }
  }
  onReferTypeDeselect(event) {
    this.getReferralNames(event);
  }
  onReferTypeSelect(event) {
    if (event.id) {
      this.getReferralNames(event);
      this.refferdMandatory = true;
    }
  }
  ngDoCheck() {
    //   if(sessionStorage && this.treatingDrModel==""){
    //     if(sessionStorage.getItem('current_doctor') && !this.treatingDrModel && this.treatingDoctor){
    //       let data = JSON.parse(sessionStorage.getItem('current_doctor'));
    //       if(data && data.doctorId){
    //       let currentDoctor = this.treatingDoctor.find((f)=>{return f.practitioner_id == data.doctorId})
    //         this.treatingDrModel = currentDoctor.practitioner_id;
    //       }else if(data && data.treatingDoctorId){
    //         let currentDoctor = this.treatingDoctor.find((f)=>{return f.practitioner_id == data.treatingDoctorId})
    //         this.treatingDrModel = currentDoctor.practitioner_id;
    //       }else if(!this.treatingDrModel){
    //         debugger;
    //       }
    //         this.loader.hideSpinner();
    //     }
    //   }else if(this.treatingDrModel && this.treatingDcotorSelector){
    //     if(this.treatingDcotorSelector.selectedItems.length==0 && this.treatingDcotorSelector._data.length>0){
    //       let currentData = this.treatingDcotorSelector._data.find((f)=>{return f.id == this.treatingDcotorSelector._defaultValue});
    //       this.treatingDcotorSelector.selectedItems.push(currentData);
    //     }
    //   }

  }
  onPayerDeselect(event) {
    this.changePayer(event.id)
  }
  onPayerSelect(event) {
    this.changePayer(event.id)
  }
  ngOnChanges(changes) {
  }
  onItemSelectOfFacility(event) {
    this.getTreatingDoctor("", event.id);
  }
  onFacilityDeselect(event) {
    this.getTreatingDoctor("", event.id);
    this.treatingDrModel = "";
    this.treatingDcotorSelector.writeValue(this.treatingDrModel);
  }
  getFacilityConfig() {
    //this.loader.showSpinner();
    let args = `config_code:facility_mgmt_doctor_0001,module_code:facility-management`
    this.baseService.get("GET_CONFIG", args, "facility_config_mapping", "facility-management", "").subscribe((result: any) => {
      if (result && result.errCode == 0) {
        if (result.resource && result.resource.length > 0) {
          let data = result.resource[0];
          if (data.config == "Yes" && data.config_value == 'yes') {
            this.isFacilityDisabled = false
          } else {
            this.isFacilityDisabled = true
          }
        }
        //this.loader.hideSpinner();
      } else {
        //TODO
        //this.loader.hideSpinner();
      }
    }, (err => {
      this.loader.hideSpinner();
    }))
  }
  getInsuranceMandatoryConfig() {
    this.baseService.get('GET_CONFIG', 'module_code:billing,config_code:billing_856', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        console.log("res is....." + result)
        if (result && result.errCode == 0 && result.resource && result.resource[0]) {
          result = result.resource[0];
          if (result.status == "active" && result.config_value == "yes") {
            this.isInsuranceMandatory = true;
          } else {
            this.isInsuranceMandatory = false;
          }
        } else {
          this.isInsuranceMandatory = false;
        }
      });
 
    }

  getRefferLetterNoMandatoryConfig() {
    this.baseService.get('GET_CONFIG', 'module_code:billing,config_code:billing_875', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        console.log("res is....." + result)
        if (result && result.errCode == 0 && result.resource && result.resource[0]) {
          result = result.resource[0];
          if (result.multivalue) {
            this.config_value = result.multivalue;
          }
        }
      });
  }
}
